import { Card, CardContent } from '@/modules/shared/components/ui/card'
import { numberFormatter } from '@/modules/shared/utils/formatter'
import type { IOrderFormJson } from '../../types/order-form-json.type'


export interface IOrderFormSummaryCardComponent {
	fieldsGroup: {
		id: string
		label: string
		campo: string
		enabled: boolean
		visible: boolean
		fieldInJsonOrder: string
		isFormat: boolean
	}[]
	jsonOrderForm: IOrderFormJson
}

export function SummaryCardComponent({
	fieldsGroup,
	jsonOrderForm,
}: IOrderFormSummaryCardComponent) {
	const formatValue = (value: any, isFormat: boolean) => {
		if (!isFormat) return value;

		const numericValue = Number(value);
		return Number.isNaN(numericValue) ? value : numberFormatter.format(numericValue);
	};

	return (
		<Card className="flex-1">
			<CardContent className="p-3">
				<div className="space-y-1">
					{fieldsGroup?.map(
						(item) =>
							item.visible && (
								<p className="text-sm" key={item.id}>
									{`${item.label}: ${formatValue(
										jsonOrderForm?.[item.fieldInJsonOrder],
										item.isFormat
									)}`}
								</p>
							),
					)}
				</div>
			</CardContent>
		</Card>
	)
}